/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shy_Deep_Trout_RunInputs */

const en_shy_deep_trout_run = /** @type {(inputs: Shy_Deep_Trout_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage`)
};

const de_shy_deep_trout_run = /** @type {(inputs: Shy_Deep_Trout_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalten`)
};

/**
* | output |
* | --- |
* | "Manage" |
*
* @param {Shy_Deep_Trout_RunInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shy_deep_trout_run = /** @type {((inputs?: Shy_Deep_Trout_RunInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shy_Deep_Trout_RunInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shy_deep_trout_run(inputs)
	return de_shy_deep_trout_run(inputs)
});